import { render } from "./textarea.html?vue&type=template&id=5fef0290&scoped=true&external"
import script from "./textarea.ts?vue&type=script&lang=js&external"
export * from "./textarea.ts?vue&type=script&lang=js&external"

import "./textarea.scss?vue&type=style&index=0&id=5fef0290&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fef0290"],['__file',"src/components/ui/textarea/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fef0290"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fef0290', __exports__)) {
    api.reload('5fef0290', __exports__)
  }
  
  module.hot.accept("./textarea.html?vue&type=template&id=5fef0290&scoped=true&external", () => {
    api.rerender('5fef0290', render)
  })

}


export default __exports__